module.exports = __webpack_public_path__ + "icon-studies.png?7ae9c13cbd1cbfabb6cc9d9dbef4a872";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/icon-studies.png
// module id = 67
// module chunks = 0